import React from 'react';
import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableHighlight,
  View,
} from '../base_components';

import DialogOverlay from './dialog_overlay';
import TextButton from '../buttons/text_button';
import ImageButton from '../buttons/image_button';
import CoinAddOverlay from './coin_add_overlay';

import CoinStore from '../../stores/coin_store';
import SwapStore from '../../stores/swap_store';
import EthTools from '../../tools/eth_tools';

const styles = StyleSheet.create({
  coinPickerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  innerOverlay: {
    width: '29rem',
    paddingTop: '1.2rem',
    paddingBottom: '1.5rem',
    height: '40rem',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: '1rem',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    marginLeft: '1.5rem',
    color: '#333',
    fontSize: '2rem',
    fontWeight: '500',
  },
  closeButton: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    width: '1.2rem',
    height: '1.2rem',
    padding: '0.9rem',
    borderRadius: '0.5rem',
  },
  searchView: {
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    marginTop: '1rem',
    alignSelf: 'stretch',
    height: '3.5rem',
    backgroundColor: '#eee',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#ddd',
    borderRadius: '0.5rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  search: {
    flex: 1,
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    color: '#333',
    fontSize: '1.4rem',
  },
  coinTitle: {
    marginLeft: '1.5rem',
    marginTop: '1rem',
    color: '#555',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  spacer: {
    flex: 1,
  },
  scroller: {
    marginTop: '0.5rem',
    marginLeft: '1rem',
    marginRight: '1rem',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollerInner: {
    flexDirection: 'column',
  },
  coinList: {
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  coin: {
    padding: '0.5rem',
    height: '5rem',
    alignSelf: 'stretch',
    borderRadius: '0.3rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageView: {
    width: '5rem',
    height: '5rem',
    borderRadius: '0.5rem',
    backgroundColor: '#333',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '5rem',
    height: '5rem',
    borderRadius: '0.5rem',
    backgroundColor: 'white',
  },
  iconText: {
    color: 'white',
    fontSize: '3rem',
  },
  middle: {
    marginLeft: '1rem',
    flex: 1,
    flexDirection: 'column',
  },
  symbolChain: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  symbol: {
    color: '#333',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  chain: {
    marginLeft: '0.5rem',
    color: '#555',
    fontSize: '1rem',
  },
  name: {
    color: '#555',
    fontSize: '1.2rem',
  },
  addButton: {
    marginTop: '1rem',
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    alignSelf: 'stretch',
  },
});

const CLOSE_IMG = require('../../assets/img/close_black.png');

type Props = {
  style?: any;
  otherCoin?: any;
  onSelect: (coin: any) => void;
  onDone: () => void;
};
type State = {
  show_add: boolean;
  search: string;
  common_coins: any;
  market_list: any;
  search_coins: any;
};
export default class CoinPickerOverlay extends React.PureComponent<
  Props,
  State
> {
  constructor(props, context) {
    super(props, context);
    const chain_id = props.otherCoin && props.otherCoin.chain_id;
    const list = CoinStore.getCommonCoins(chain_id);
    const common_coins = this._filterList(list);
    this.state = {
      show_add: false,
      search: '',
      common_coins,
      market_list: null,
      search_coins: null,
    };
  }
  componentDidMount() {
    if (this.props.otherCoin) {
      SwapStore.addChangeListener(this._onSwapChange);
      SwapStore.fetchMarketList(this.props.otherCoin);
      this._onSwapChange();
    }
  }
  componentWillUnmount() {
    if (this.props.otherCoin) {
      SwapStore.removeChangeListener(this._onSwapChange);
    }
  }
  _onSwapChange = () => {
    const market_list = SwapStore.getMarketList(this.props.otherCoin);
    this.setState({ market_list });
  };
  _onSearchChange = (search) => {
    const chain_id = this.props.otherCoin && this.props.otherCoin.chain_id;
    let search_coins = [];
    if (search) {
      search_coins = CoinStore.search(search, chain_id);
    }
    this.setState({ search, search_coins });
  };
  _onCoinPress = (coin) => this.props.onSelect(coin);
  _filterList(list) {
    const { excludeCoin } = this.props;
    let ret = list;
    if (excludeCoin) {
      ret = list.filter((coin) => coin.coin_id !== excludeCoin.coin_id);
    }
    return ret;
  }
  _onAddPress = () => this.setState({ show_add: true });
  _onAddDone = () => this.setState({ show_add: false });

  render() {
    const { style, onDone } = this.props;
    const { show_add, search, common_coins, search_coins } = this.state;

    let coins = null;
    const label = search ? 'Results' : 'Common Coins';
    const list = search ? search_coins : common_coins;
    if (list.length === 0) {
    } else {
      coins = list.map((coin) => (
        <Coin key={coin.coin_id} coin={coin} onPress={this._onCoinPress} />
      ));
    }

    let content = null;
    if (show_add) {
      content = <CoinAddOverlay onDone={this._onAddDone} />;
    } else {
      content = (
        <View style={[styles.coinPickerOverlay, style]}>
          <DialogOverlay style={styles.innerOverlay} onOutsidePress={onDone}>
            <Text style={styles.title}>Select A Coin</Text>
            <View style={styles.searchView}>
              <TextInput
                style={styles.search}
                value={search}
                onChangeText={this._onSearchChange}
                placeholder='Search Coins'
              />
            </View>
            <Text style={styles.coinTitle}>{label}</Text>
            <ScrollView
              style={styles.scroller}
              contentContainerStyle={styles.scrollerInner}
            >
              <View style={styles.coinList}>{coins}</View>
            </ScrollView>
            <TextButton
              style={styles.addButton}
              type='default'
              text='Add Token'
              onPress={this._onAddPress}
            />
            <ImageButton
              style={styles.closeButton}
              underlayColor='rgba(0,0,0,0.3)'
              source={CLOSE_IMG}
              onPress={onDone}
            />
          </DialogOverlay>
        </View>
      );
    }
    return content;
  }
}

function Coin(props) {
  const { chain_id, name, symbol, icon_uri } = props.coin;

  function _onPress() {
    props.onPress(props.coin);
  }

  let image = null;
  if (icon_uri) {
    image = (
      <Image
        style={styles.icon}
        resizeMode='contain'
        source={{ uri: icon_uri }}
      />
    );
  } else {
    image = (
      <Text style={styles.iconText}>{symbol.substr(0, 1).toUpperCase()}</Text>
    );
  }
  const chain = EthTools.getChainName(chain_id);

  return (
    <TouchableHighlight
      style={styles.coin}
      underlayColor='rgba(0,0,0,0.2)'
      onPress={_onPress}
    >
      <View style={styles.imageView}>{image}</View>
      <View style={styles.middle}>
        <View style={styles.symbolChain}>
          <Text style={styles.symbol}>{symbol}</Text>
          <Text style={styles.chain}>({chain})</Text>
        </View>
        <Text style={styles.name}>{name}</Text>
      </View>
    </TouchableHighlight>
  );
}
